import React from "react";

export default function ScrollablePillSelector(props) {
	console.log("Pill selector items:", items);
  var items = props.items;
  var selectedId = props.selectedId;
  var onSelect = props.onSelect;

  var styles = {

    container: {
      width: "100%",
      overflow: "hidden"
    },

    scroll: {
      display: "flex",
      flexDirection: "row",
      gap: "8px",
      overflowX: "auto",
      padding: "8px 4px",
      WebkitOverflowScrolling: "touch"
    },

    pill: {
      borderRadius: "20px",
      padding: "8px 14px",
      border: "1px solid #ccc",
      backgroundColor: "#f5f5f5",
      color: "#333",
      cursor: "pointer",
      whiteSpace: "nowrap",
      fontSize: "14px"
    },

    pillSelected: {
      backgroundColor: "#1f6fd6",   // placeholder – swap to your constants
      borderColor: "#1f6fd6",
      color: "#ffffff"
    }

  };

  function handleClick(id) {
    if (onSelect) {
      onSelect(id);
    }
  }

  function renderPill(item) {

    var isSelected = item.id === selectedId;

    var pillStyle = styles.pill;
    if (isSelected) {
      pillStyle = Object.assign({}, styles.pill, styles.pillSelected);
    }

    return (
      <button
        key={item.id}
        type="button"
        style={pillStyle}
        onClick={function () { handleClick(item.id); }}
      >
        {item.label}
      </button>
    );
  }

  return (
    <div style={styles.container}>
	
      <div style={styles.scroll}>
        {items && items.map(function (item) {
          return renderPill(item);
        })}
      </div>
    </div>
  );
}
